import { render } from "./GeneralIssueWithInteractionDialog.vue?vue&type=template&id=b0549980&scoped=true"
import script from "./GeneralIssueWithInteractionDialog.vue?vue&type=script&lang=js"
export * from "./GeneralIssueWithInteractionDialog.vue?vue&type=script&lang=js"

import "./GeneralIssueWithInteractionDialog.vue?vue&type=style&index=0&id=b0549980&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0549980"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
